import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PointViewComponent } from './point-view/point-view.component';
import { SharedModule } from '../shared/shared.module';
import { TaskModule } from '../task/task.module';
import { RouterModule } from '@angular/router';
import { NgPipesModule } from 'ngx-pipes';


@NgModule({
  declarations: [PointViewComponent],
  imports: [
    CommonModule, SharedModule, TaskModule, RouterModule,
    NgPipesModule
  ],
  exports: [
    PointViewComponent
  ]
})
export class PointModule { }
